import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import {
	Box,
	Heading,
	HStack,
	Spacer,
	ButtonGroup,
	Button,
	IconButton,
	Table,
	Tbody,
	Td,
	Th,
	Thead,
	Tr,
	Badge,
	useColorModeValue as mode,
} from '@chakra-ui/react'
import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons'
import { RiAddFill } from 'react-icons/ri'
import { format } from 'date-fns'
import { useAuth } from '../../context/auth'
import { useOrderGroup } from '../../context/order-group'
// import { OrderGroup } from '../../types/order_group'
import { OrderGroupBadgeEnum, OrderGroupStatusEnum } from '../../constants/order_group'

export default function OrderGroups() {
	const { isAuthenticated } = useAuth()
	const { orderGroups, totalPage, fetchOrderGroups, isLoadingOrderGroups } = useOrderGroup()
	const [currentPage, setCurrentPage] = useState(1)
	const [buttons, setButtons] = useState<JSX.Element[]>([])

	const router = useRouter()

	useEffect(() => {
		setCurrentPage(Number(router.query.page))
	}, [router.query.page])

	useEffect(() => {
		isAuthenticated && fetchOrderGroups(currentPage)
	}, [isAuthenticated, currentPage])

	useEffect(() => {
		if (!totalPage) {
			return
		}

		const buttons: JSX.Element[] = []

		for (let i = 1; i <= totalPage; i++) {
			buttons.push(
				<Button
					key={i}
					variant="ghost"
					onClick={() => router.push(`?page=${i}`)}
					colorScheme={i === currentPage ? 'black' : 'teal'}
				>
					{i}
				</Button>
			)
		}

		setButtons(buttons)
	}, [totalPage])

	// const orderGroupStatus = (orderGroup: OrderGroup): string => {
	// 	const backlogCount = orderGroup.orders.filter((order) => order.pickup_at === null).length

	// 	// 発注待ちの注文がある
	// 	if (backlogCount > 0) {
	// 		return `発注待ち${backlogCount}件`
	// 	}

	// 	return ''
	// }

	return isLoadingOrderGroups ? (
		<Box>Loading...</Box>
	) : orderGroups ? (
		<>
			<Box as="section">
				<HStack mb={4}>
					<Heading size="md">商品管理</Heading>
					<Spacer />
					<ButtonGroup size="sm" variant="outline">
						<Button
							iconSpacing="1"
							leftIcon={<RiAddFill fontSize="1.25em" />}
							onClick={() => router.push('/order_groups/new')}
						>
							注文を作成する
						</Button>
					</ButtonGroup>
				</HStack>
				<Table borderWidth="1px" fontSize="sm" size="sm">
					<Thead bg={mode('gray.50', 'gray.800')}>
						<Tr>
							<Th whiteSpace="nowrap" scope="col">
								注文
							</Th>
							<Th whiteSpace="nowrap" scope="col">
								注文日
							</Th>
							<Th whiteSpace="nowrap" scope="col">
								配達日
							</Th>
							<Th whiteSpace="nowrap" scope="col">
								お客様
							</Th>
							<Th whiteSpace="nowrap" scope="col">
								合計
							</Th>
							<Th whiteSpace="nowrap" scope="col">
								ステータス
							</Th>
							<Th whiteSpace="nowrap" scope="col" />
							<Th />
						</Tr>
					</Thead>
					{isLoadingOrderGroups ? (
						<Box p={4}>Loading...</Box>
					) : (
						<Tbody>
							{orderGroups.map((orderGroup, index) => (
								<Tr key={index}>
									<Td whiteSpace="nowrap">#{orderGroup.id}</Td>
									<Td whiteSpace="nowrap">
										{format(new Date(orderGroup.created_at), 'yyyy-MM-dd HH:mm')}
									</Td>
									<Td whiteSpace="nowrap">
										{format(new Date(orderGroup.deliver_at), 'yyyy-MM-dd HH:mm')}
									</Td>
									<Td whiteSpace="nowrap">{orderGroup.name}</Td>
									<Td whiteSpace="nowrap">{orderGroup.price.toLocaleString()}円</Td>
									<Td whiteSpace="nowrap">
										<Badge
											fontSize="md"
											colorScheme={OrderGroupBadgeEnum[orderGroup.status]}
											variant="outline"
											p={1}
										>
											{OrderGroupStatusEnum[orderGroup.status]}
										</Badge>
									</Td>
									{/* <Td whiteSpace="nowrap">{orderGroupStatus(orderGroup)}</Td> */}
									<Td textAlign="right">
										<Button
											variant="link"
											colorScheme="blue"
											onClick={() => router.push('/order_groups/' + orderGroup.id)}
										>
											詳細
										</Button>
									</Td>
								</Tr>
							))}
						</Tbody>
					)}
				</Table>

				{currentPage > 1 && (
					<IconButton
						colorScheme="teal"
						variant="ghost"
						aria-label="previous page"
						icon={<ArrowBackIcon />}
						onClick={() => router.push(`?page=${currentPage - 1}`)}
					/>
				)}
				{buttons.map((button) => button)}
				{totalPage && currentPage < totalPage && (
					<IconButton
						colorScheme="teal"
						variant="ghost"
						aria-label="next page"
						icon={<ArrowForwardIcon />}
						onClick={() => router.push(`?page=${currentPage + 1}`)}
					/>
				)}
			</Box>
		</>
	) : (
		<></>
	)
}
